/* Animated stats — counts the number up from 0 when the element scrolls into
   view. Progressive enhancement: the final value ships in the markup, so with
   no JS, reduced motion, or no IntersectionObserver support the real number is
   simply shown immediately. Handles decimals ("4.9") and thousands grouping
   ("10,000"), preserving whichever format the merchant typed. */
(function () {
  'use strict';
  if (customElements.get('animated-stat')) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function parseTarget(raw) {
    var str = String(raw || '').trim();
    var cleaned = str.replace(/[^0-9.\-]/g, '');
    var value = parseFloat(cleaned);
    if (isNaN(value)) return null;
    var dot = cleaned.indexOf('.');
    return {
      value: value,
      decimals: dot === -1 ? 0 : cleaned.length - dot - 1,
      grouped: str.indexOf(',') !== -1
    };
  }

  function format(value, target) {
    var fixed = value.toFixed(target.decimals);
    if (!target.grouped) return fixed;
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  customElements.define(
    'animated-stat',
    class extends HTMLElement {
      connectedCallback() {
        this.numberEl = this.querySelector('[data-stat-number]');
        if (!this.numberEl) return;

        this.target = parseTarget(this.dataset.value || this.numberEl.textContent);
        // Unparseable, reduced motion, or no IO support: leave the final value.
        if (
          !this.target ||
          reducedMotion.matches ||
          !('IntersectionObserver' in window) ||
          document.body.getAttribute('data-animations') === 'false'
        ) {
          return;
        }

        // Reconnected after already animating (e.g. block reordered in the
        // theme editor): show the final value instead of resetting to 0.
        if (this._started) {
          this.numberEl.textContent = format(this.target.value, this.target);
          return;
        }

        // Reserve the final width so the row doesn't shift while counting.
        var finalWidth = this.numberEl.getBoundingClientRect().width;
        if (finalWidth > 0) this.numberEl.style.minWidth = Math.ceil(finalWidth) + 'px';

        this.numberEl.textContent = format(0, this.target);

        var self = this;
        this._io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                self._io.disconnect();
                self._start();
              }
            });
          },
          { threshold: 0.4 }
        );
        this._io.observe(this);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
        if (this._raf) cancelAnimationFrame(this._raf);
      }

      _start() {
        if (this._started) return;
        this._started = true;

        var duration = parseInt(this.dataset.duration, 10) || 1400;
        var target = this.target;
        var el = this.numberEl;
        var self = this;
        var startTime = null;

        function tick(now) {
          if (startTime === null) startTime = now;
          var progress = Math.min((now - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
          el.textContent = format(target.value * eased, target);
          if (progress < 1) {
            self._raf = requestAnimationFrame(tick);
          } else {
            el.textContent = format(target.value, target);
          }
        }

        this._raf = requestAnimationFrame(tick);
      }
    }
  );
})();
